import { Component, inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GungFlowService } from '../../../services/gung-flow/gung-flow.service';
import { GungFlowNavigationService } from '../../../services/gung-flow-navigation/gung-flow-navigation.service';
import { first } from 'rxjs';
import { GungFlow } from './../../../state/flow/types';

@Component({
    selector: 'lib-gung-flow-details',
    templateUrl: './gung-flow-details.component.html',
    styleUrls: ['./gung-flow-details.component.css'],
    standalone: false
})
export class GungFlowDetailsComponent implements OnInit {
  protected route = inject(ActivatedRoute);
  protected router = inject(Router);
  protected gungFlowService = inject(GungFlowService);
  protected flowNavigation = inject(GungFlowNavigationService);

  isMultidropEnabled = false;
  curentGungFlow: GungFlow;

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.gungFlowService
        .getGungFlow(params.get('flowId'), true)
        .pipe(first())
        .subscribe(gungFlow => {
          this.curentGungFlow = JSON.parse(JSON.stringify(gungFlow));
        });
    });
    this.isMultidropEnabled = this.gungFlowService.isMultiDropFlowsEnabled;
  }

  cancelChanges(): void {
    this.router.navigateByUrl(this.flowNavigation.listUrl());
  }

  saveCurrentUser(): void {
    this.gungFlowService
      .updateGungFlow(this.curentGungFlow)
      .pipe(first())
      .subscribe(gungFlow => {
        this.router.navigateByUrl(this.flowNavigation.listUrl());
        this.gungFlowService.getGungFlows(true).subscribe();
      });
  }

  deleteFlow(): void {
    const message = 'Delete flow?';
    if (confirm(message)) {
      this.gungFlowService
        .deleteGungFlow(this.curentGungFlow)
        .pipe(first())
        .subscribe(gungFlow => {
          this.router.navigateByUrl(this.flowNavigation.listUrl());
          this.gungFlowService.getGungFlows(true).subscribe();
        });
    }
  }
}
